(function($) {$(document).ready(function() {

	$('.campus-cols__heading').on('click', toggleMobileColumn);

	$('.campus-cols__courses-title').on('click', toggleCourses);

	function toggleMobileColumn(event) {
		if (window.innerWidth >= 1024) return;
		
		const $this = $(this);

		$this
			.closest('.campus-cols__col')
			.toggleClass('open')
			.find('.campus-cols__main')
			.slideToggle();

		$this
			.siblings('.campus-cols__thumb')
			.slideToggle();
	}

	function toggleCourses(event) {
		if (window.innerWidth >= 1024) return;
		
		const $this = $(this);

		$this
			.toggleClass('open')
			.siblings('.campus-cols__courses')
			.slideToggle();
	}

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);